import wx from './gecWeixin'
const VueGecWxJssdk = {}
VueGecWxJssdk.install = function (Vue, options) {
  Vue.prototype.$wx = wx
}
export default VueGecWxJssdk
